module.exports = __webpack_public_path__ + "static/img/32.db70338.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/publicService/digitalize/32.png
// module id = MXlC
// module chunks = 2